<template>
    <div>
        <div class="card" v-if="nouvelleRegle==false">
            <header class="card-header">
                <p class="card-header-title">
                    {{regle.libRegle}}
                </p>
                <a class="card-header-icon" @click="Editer">
                    <span class="icon">
                        <i class="fas fa-edit" aria-hidden="true"></i>
                    </span>
                </a>
            </header>
            <div class="card-content">
                <div class="content">
                    <div class="level">
                        <div class="level-item has-text-centered">
                            <div>
                                <p class="heading">Actions</p>
                                <div class="field is-grouped is-grouped-multiline">
                                    <div class="control" v-for="action in regle.actions" :key="action.idAction">
                                        <div class="tags has-addons">
                                        <span class="tag is-light">{{action.idOptionInterface | libelleOptionInterface}}</span>
                                        <span class="tag is-info" v-if="action.valeur" >{{ action.valeur }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="level-item has-text-centered">
                            <div>
                            <p class="heading">Condition</p>
                            <p>{{regle.libCondition}}</p>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>

        <div class="card" v-if="nouvelleRegle==true">
            <div class="card-content">
                <div class="content">
                    <a class="button" @click="NouvelleRegle">
                        <span class="icon">
                            <i class="fas fa-plus-circle"></i>
                        </span>
                        <span>Nouvelle Régle</span>
                    </a>
                </div>
            </div>
        </div> 

        <div class="modal" v-bind:class="{ 'is-active': EditerRegle }">
            <div class="modal-background"></div>
                <div class="modal-card">
                    <header class="modal-card-head">
                        <span class="icon is-large">
                            <i class="fas fa-lg fa-bolt"></i>
                        </span>
                        <!-- Libellé régle -->
                        <div class="field">
                            <label class="label">Libellé de la régle :</label>
                            <div class="control">
                                <input class="input" type="text" v-model="regleEditee.libRegle">
                            </div>
                        </div>
                    </header>
                    <section class="modal-card-body">
                        <div class="tabs is-centered">
                            <ul>
                                <li v-bind:class="{ 'is-active': activeTab===0 }" @click="activeTab=0">
                                <a>
                                    <span class="icon is-small"><i class="fas fa-cog" aria-hidden="true"></i></span>
                                    <span>Actions</span>
                                </a>
                                </li>
                                <li v-bind:class="{ 'is-active': activeTab===1 }" @click="activeTab=1">
                                <a>
                                    <span class="icon is-small"><i class="fas fa-tasks" aria-hidden="true"></i></span>
                                    <span>Condition</span>
                                </a>
                                </li>
                            </ul>
                        </div>
                        <!-- Tab actions -->
                        <div v-show="activeTab===0" >
                            <!-- Listes options affectées -->
                            <div class="field is-grouped is-grouped-multiline">
                                <label class="label" v-if="actionsSelected.length > 0">Actions paramétrées :</label>
                                <div class="control" v-for="action in actionsSelected" :key="action.idOptionInterface">
                                    <div class="tags has-addons">
                                    <span class="tag is-light">{{action.idOptionInterface | libelleOptionInterface}}</span>
                                    <span class="tag is-info" v-if="action.valeur" >{{ action.valeur }}</span>
                                    <a class="tag is-delete is-danger" @click="SupprimerOption(action.idOptionInterface)"></a>
                                    </div>
                                </div>
                            </div>                            
                            <!-- Liste options disponibles -->
                            <div class="field">
                                <label class="label">Actions disponibles :</label>
                                <div class="control has-icons-left">
                                    <div class="select is-multiple">
                                        <select v-model="actionSelected">
                                            <option v-for="option in this.outputOptionsInterfaces" :key="option.idOptionInterface" :value="option">{{option.libelle}}</option>
                                        </select>
                                    </div>
                                    <div class="icon is-small is-left">
                                        <i class="far fa-play-circle"></i>
                                    </div>
                                </div>
                            </div>
                            <!-- Valeur -->
                            <div class="field" v-show="actionSelected.idUnite">
                                {{ actionSelected.description }} en {{ actionSelected.idUnite | libelleUnite }}
                                <span v-if="actionSelected.defaut"> (valeur par défaut : {{ actionSelected.defaut }})</span>
                                <input class="input" type="text" placeholder="valeur" v-model="valeur" >
                            </div>
                            <!-- Bouton ajouter -->
                            <div class="field" v-if="actionSelected.idOptionInterface">
                                <div class="control">
                                    <button class="button is-success" @click="AjouterOption">
                                        <span class="icon is-small">
                                            <i class="fas fa-plus"></i>
                                        </span>
                                        <span>Ajouter</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <!-- Tab condition -->
                        <div v-show="activeTab===1" >                                    
                            <!-- Condition -->
                            <div class="field">
                                <label class="label">Condition d'activation :</label>
                                <div class="control">
                                    <textarea class="textarea" v-model="libCondition" ></textarea>
                                </div>
                            </div>
                            <!-- Complétion condition -->
                            <div class="field">
                                <label class="label">Entrées disponibles :</label>
                                <div class="control has-icons-left">
                                    <div class="select is-multiple">
                                        <select v-model="inputSelected">
                                            <option v-for="option in this.inputOptionsInterfaces" :key="option.idOptionInterface" :value="option">{{option.libelle}}</option>
                                        </select>
                                    </div>
                                    <div class="icon is-small is-left">
                                        <i class="far fa-play-circle"></i>
                                    </div>
                                </div>
                            </div>
                            <!-- Bouton insérer -->
                            <div class="field" v-if="inputSelected.idOptionInterface">
                                <div class="control">
                                    <button class="button is-success" @click="ConcatenerCondition(inputSelected.libelle)">
                                        <span class="icon is-small">
                                            <i class="fas fa-plus"></i>
                                        </span>
                                        <span>Insérer</span>
                                    </button>
                                </div>
                            </div>
                        </div>

                    </section>
                    <footer class="modal-card-foot">
                        <a class="button is-danger" @click="Supprimer" v-if="!nouvelleRegle">
                            <span class="icon is-small">
                                <i class="fas fa-trash-alt"></i>
                            </span>
                        </a>
                        <a class="button is-success" @click="Enregistrer" v-if="nouvelleRegle">
                            <span class="icon is-small">
                                <i class="fas fa-check"></i>
                            </span>
                            <span>Enregistrer</span>
                        </a>
                        <a class="button is-success" @click="Modifier" v-if="!nouvelleRegle">
                            <span class="icon is-small">
                                <i class="fas fa-check"></i>
                            </span>
                            <span>Modifier</span>
                        </a>
                    </footer>
                </div>
            <button class="modal-close is-large" aria-label="close" @click="EditerRegle=false"></button>
        </div>

    </div>
</template>

<script>
import optionInterfaceFilter from '../filters/optionInterfaceFilter'
import uniteFilter from '../filters/uniteFilter'

export default {
    props : {
        regle: {},
        nouvelleRegle: {
            type: Boolean,
            defaut: false
        }
    },
    data() {
        return {
            EditerRegle: false,
            regleEditee: {},
            libCondition: '',
            actionSelected: {}, // Action sélectionnée dans la liste
            inputSelected: {}, // Entrée/Variable sélectionnée
            valeur: '',
            actionsSelected: [], // Actions affectées à la régle
            activeTab: 0
        }
    },
    created() {
        this.init()
    },
    computed: {
        outputOptionsInterfaces() {
            return this.$store.getters.getOptionsInterfaces('S')
        },
        inputOptionsInterfaces() {
            return this.$store.getters.getOptionsInterfaces('E')
        }
    },
    methods: {
        init () {
            this.activeTab = 0
            this.regleEditee = {}
            this.actionSelected = {}
            this.valeur = ''
            this.actionsSelected = []
            this.inputSelected = {}
            if (!this.nouvelleRegle) {               
                this.regleEditee = JSON.parse(JSON.stringify(this.regle))
                this.regleEditee.actions.forEach(actionExistante => {
                    let action = {
                        idOptionInterface: actionExistante.idOptionInterface,
                        valeur: actionExistante.valeur
                    }
                    this.actionsSelected.push(action)
                })
                this.libCondition = this.regleEditee.libCondition
            }
        },
        NouvelleRegle () {
            this.init ()
            this.EditerRegle = true
        },
        AjouterOption() {
            // Vérifier que l'option d'interface n'est pas déjà présente
            // Si oui, la supprimer avant de la recréer
            this.SupprimerOption(this.actionSelected.idOptionInterface)
            // Sauvegarde saisie
            let action = {
                idOptionInterface: this.actionSelected.idOptionInterface,
                valeur: this.valeur
            }
            this.actionsSelected.push(action)
            // Réinit la saisie
            this.actionSelected = {}
            this.valeur = ''
        },
        SupprimerOption(idOptionInterface) {
            let index = this.actionsSelected.findIndex(optionInterface => optionInterface.idOptionInterface == idOptionInterface)
            if (index >= 0) {
                this.actionsSelected.splice(index, 1)
            }
        },
        ConcatenerCondition(libelle) {
            this.libCondition += '{' + libelle + '}'
        },
        Enregistrer() {
            var vm = this
            this.Formatter()
            this.$store.dispatch('creerRegle', this.regleEditee)
            .then(() => {
                this.PasEditer()
                this.Change()
            })
            .catch((error) => {
                this.$notify({
                group: 'global',
                type: 'error',
                title: 'Erreur lors de la création de la régle ' + vm.regleEditee.libRegle,
                text: error.response.data.libellesMessages,
                duration: -1
                })
            });
        },
        Modifier() {
            var vm = this
            this.Formatter()
            this.$store.dispatch('modifierRegle', this.regleEditee)
            .then(() => {
                this.PasEditer()
                this.Change()
            })
            .catch((error) => {
                this.$notify({
                group: 'global',
                type: 'error',
                title: 'Erreur lors de la modification de la régle ' + vm.regleEditee.libRegle,
                text: error.response.data.libellesMessages,
                duration: -1
                })
            });

        },
        Supprimer() {
            var vm = this
            this.Formatter()
            this.$store.dispatch('supprimerRegle', this.regleEditee)
            .then(() => {
                this.PasEditer()
                this.Change()
            })
            .catch((error) => {
                this.$notify({
                group: 'global',
                type: 'error',
                title: 'Erreur lors de la suppression de la régle ' + vm.regleEditee.libRegle,
                text: error.response.data.libellesMessages,
                duration: -1
                })
            });
        },
        Editer() {
            this.init()
            this.EditerRegle = true
        },
        PasEditer() {
            this.EditerRegle = false
        },
        Formatter() {
            let actions = []
            this.actionsSelected.forEach(action => {
                let nouvelleAction = {
                    idOptionInterface: action.idOptionInterface,
                    valeur: action.valeur
                }
                // Récupérer l'id de l'action si déjà existante
                if (this.regleEditee.actions) {
                    this.regleEditee.actions.forEach(actionExistante => {
                        if (actionExistante.idOptionInterface == nouvelleAction.idOptionInterface) {
                            nouvelleAction.idAction = actionExistante.idAction
                        }
                    })
                }
                actions.push(nouvelleAction)
            });
            this.regleEditee.actions = actions
            this.regleEditee.libCondition = this.libCondition
        },
        Change() {
            this.$emit("change")
        }
    },
    filters: {
        libelleOptionInterface: optionInterfaceFilter.libelle,
        symboleUnite: uniteFilter.symbole,
        libelleUnite: uniteFilter.libelle
    }
}
</script>

<style scoped>
.level-item { 
  flex-shrink: 1; 
}
</style>
